<template>
  <div>
    STERNE
  </div>
</template>

<script>

export default {
  name: "",
  data: () => ({
  }),
  mounted() {
  },
  computed: {
  },
  methods: {
  },
  components: {
  }
}
</script>

<style scoped>
</style>
